import { TextField, DateField, FunctionField } from "react-admin";
import { StaffRequestStatus } from "utils/choices";
import TravelersField from "server/components/Fields/TravelersField";
import LocationsField from "server/components/Fields/LocationsField";
import { MobileListRow } from "features/MobileListRow";

export const statusLabel = rec =>
  rec?.staffRequest ? StaffRequestStatus.find(s => s.id === rec.staffRequest.status)?.name ?? "-" : "-";

// Shared by the trips list and the business-trip reports list — same columns, different row actions.
export const tripColumns = () => [
  <TextField
    key="id"
    source="id"
    label="№"
  />,
  <TravelersField
    key="travelers"
    label="Именa"
  />,
  <LocationsField
    key="locations"
    source="locations"
    label="Локации"
  />,
  <DateField
    key="createdOn"
    source="staffRequest.createdOn"
    label="Дата на подаване"
    locales="bg-BG"
    sortable={false}
    emptyText="—"
  />,
  <DateField
    key="dateFrom"
    source="dateFrom"
    label="Начална дата"
    locales="bg-BG"
    sortable={false}
  />,
  <DateField
    key="dateTo"
    source="dateTo"
    label="Крайна дата"
    locales="bg-BG"
    sortable={false}
  />,
  <TextField
    key="dailyAllowanceDays"
    source="dailyAllowanceDays"
    label="Брой дни"
  />,
  <FunctionField
    key="status"
    label="Статус"
    sortable={false}
    render={statusLabel}
  />,
];

export const tripMobileRows = rec => (
  <div>
    <MobileListRow fields={[{ label: "№", value: rec?.id }]} />
    <MobileListRow fields={[{ label: "Рег. №", value: rec?.registryNumber ?? "—" }]} />
    <MobileListRow fields={[{ label: "Локации", value: <LocationsField source="locations" /> }]} />
    <MobileListRow fields={[{ label: "Начална дата", value: <DateField source="dateFrom" locales="bg-BG" /> }]} />
    <MobileListRow fields={[{ label: "Крайна дата", value: <DateField source="dateTo" locales="bg-BG" /> }]} />
    <MobileListRow fields={[{ label: "Брой дни", value: rec?.dailyAllowanceDays }]} />
    <MobileListRow
      fields={[
        {
          label: "Дата на подаване",
          value: (
            <DateField
              source="staffRequest.createdOn"
              locales="bg-BG"
              emptyText="—"
            />
          ),
        },
      ]}
    />
    <MobileListRow fields={[{ label: "Статус", value: statusLabel(rec) }]} />
  </div>
);
